module.exports = __webpack_public_path__ + "img/dischem-logo.ce926154.png";